import slide1 from './slide-1/slide-1.vue';
import slide2 from './slide-2/slide-2.vue';
import slide3 from './slide-3/slide-3.vue';
import slide4 from './slide-4/slide-4.vue';
import slide5 from './slide-5/slide-5.vue';
import slide6 from './slide-6/slide-6.vue';
import slide7 from './slide-7/slide-7.vue';
import slide8 from './slide-8/slide-8.vue';
import slide9 from './slide-9/slide-9.vue';
import slide10 from './slide-10/slide-10.vue';

export default { slide1, slide2, slide3, slide4, slide5, slide6, slide7, slide8, slide9, slide10 };